// Elastic user rvc_webapp (read only)
export const AUTH_TOKEN = "Basic ZWxhc3RpYzplbGFzdGljcGFzc3dvcmQ=";

export const ENDPOINTS = {
  ICD: "/es/icd/_search",
  PROVIDER_GROUPS: "/es/provider_groups*/_search",
};
